import i18n from "@/locales/index";
const _t = i18n.global.t;


export const getNowDate = () => {
  const yy = new Date().getFullYear()
  const MM = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)
  const dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
  const HH = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
  const mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
  const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
  return yy + '-' + MM + '-' + dd + ' ' + HH + ':' + mm + ':' + ss
}

export const formatSeconds = (value: any) => {
  var secondTime: any = parseInt(value);// 秒
  var minuteTime: any = 0;// 分
  var hourTime: any = 0;// 小时
  if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt((secondTime / 60).toString());
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt((secondTime % 60).toString());
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt((minuteTime / 60).toString());
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt((minuteTime % 60).toString());
    }
  }
  // var result = "" + parseInt(secondTime) + "秒";
  var result = hourTime + _t('home.hour') + minuteTime + _t('home.min')

  // if(minuteTime > 0) {
  //     result = "" + parseInt(minuteTime) + _t('home.hour') + result;
  // }
  // if(hourTime > 0) {
  //     result = "" + parseInt(hourTime) + "小时" + result;
  // }
  return result;
}

export const timeBlankSpaceFormat = (value: any) => {
  var secondTime: any = parseInt(value);// 秒
  var minuteTime: any = 0;// 分
  var hourTime: any = 0;// 小时
  var result
  if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt((secondTime / 60).toString());
    //获取秒数，秒数取佘，得到整数秒数
    secondTime = parseInt((secondTime % 60).toString());
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt((minuteTime / 60).toString());
      //获取小时后取佘的分，获取分钟除以60取佘的分
      minuteTime = parseInt((minuteTime % 60).toString());
      result = hourTime + ' ' + _t('home.hour') + ' ' + minuteTime + ' ' + _t('home.min')

    } else {
      result = minuteTime + ' ' + _t('home.minute')

    }
  }else {
    result = minuteTime + ' ' + _t('home.minute')
  }
  // var result = "" + parseInt(secondTime) + "秒";

  return result;
}


// export default getNowDate